module.exports = __webpack_public_path__ + "img/play-button-desktop.b8fc739547d686bbbc3795ca53a08610.svg";